// Import Olympe runtime or DRAW
import 'olympe';

// Import project bricks (we use webpack-import-glob-loader to import all bricks)
import './common/MatomoRequest.js';
import './web/matomo/helper.js'; import './web/matomo/MatomoInsertTrackingCode.js'; import './web/matomo/MatomoPrepareParameters.js'; import './web/matomo/MatomoTrackSomething.js';

